import type { CoverageProblem } from "@/lib/coverage/coverageProblems";

export function CoverageProblems({ problems }: { problems: CoverageProblem[] }) {
  if (problems.length === 0) return null;
  return (
    <section className="rounded-lg border border-amber-200 bg-amber-50 p-3 dark:border-amber-900 dark:bg-amber-950/40">
      <h3 className="text-sm font-semibold text-amber-950 dark:text-amber-100">On open</h3>
      <ul className="mt-2 space-y-2">
        {problems.map((problem, index) => (
          <li key={`${problem.id}-${index}`} className="text-sm text-amber-950 dark:text-amber-50">
            <span className="font-medium">{problem.title}.</span> {problem.detail}
          </li>
        ))}
      </ul>
    </section>
  );
}
